import WidgetSetupLayout from 'components/posts/detail/layout/widgetsSetup/WidgetsSetupLayout';
import WidgetsSetupProvider, {
  useWidgetsSetup,
} from 'components/posts/detail/layout/widgetsSetup/WidgetsSetupProvider';

const WidgetsSetup = {
  Root: WidgetsSetupProvider,
  Layout: WidgetSetupLayout,
  useWidgetsSetup: useWidgetsSetup,
};

export default WidgetsSetup;
